import { CountUp } from '../../../lib/countUp/countUp'
export const keyNumber = () => {
  const numbers = document.querySelectorAll('.key_numbers_component .key_number span')
  const langcode = document.querySelector('html').getAttribute('lang')
  const decimalSeparator = langcode === 'fr' ? ',' : '.'

  if (numbers?.length) {
    numbers.forEach((number) => {
      const targetNumber = number.innerText

      if (targetNumber) {
        let separator = ' '
        separator = langcode === 'fr' && targetNumber.indexOf('.') > 0 ? '.' : separator
        separator = langcode === 'en' ? ',' : separator

        const countDecimal = langcode === 'fr' ? targetNumber.replace(/[/€$%\s]/g, '').split('.')[1]?.length : targetNumber.replace(/[/€$%\s]/g, '').split('.')[1]?.length

        const demo = new CountUp(number, targetNumber, { enableScrollSpy: true, decimal: decimalSeparator, separator: separator, decimalPlaces: countDecimal })
        if (!demo.error) {
          demo.start()
        } else {
          console.error(demo.error)
        }
      }
    })
  }
}
